var _g;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

function SvgSearch(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 49.64 50.66"
  }, props), _g || (_g = /*#__PURE__*/React.createElement("g", {
    "data-name": "Layer 2"
  }, /*#__PURE__*/React.createElement("g", {
    "data-name": "Layer 1"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M19.62 39.24a19.62 19.62 0 1119.62-19.62 19.64 19.64 0 01-19.62 19.62zm0-37.24a17.62 17.62 0 1017.62 17.62A17.63 17.63 0 0019.62 2z",
    "data-name": "Ellipse 2"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M48.64 50.66a1 1 0 01-.71-.29L32.16 34.6a1 1 0 010-1.42 1 1 0 011.41 0L49.35 49a1 1 0 01-.71 1.7z",
    "data-name": "Path 1"
  })))));
}

export default "data:image/svg+xml;base64,PHN2ZyB4bWxucz0iaHR0cDovL3d3dy53My5vcmcvMjAwMC9zdmciIHZpZXdCb3g9IjAgMCA0OS42NCA1MC42NiI+PGcgaWQ9IkxheWVyXzIiIGRhdGEtbmFtZT0iTGF5ZXIgMiI+PGcgaWQ9IkxheWVyXzEtMiIgZGF0YS1uYW1lPSJMYXllciAxIj48ZyBpZD0ic2VhcmNoIj48ZyBpZD0iRWxsaXBzZV8yIiBkYXRhLW5hbWU9IkVsbGlwc2UgMiI+PHBhdGggZD0iTTE5LjYyLDM5LjI0QTE5LjYyLDE5LjYyLDAsMSwxLDM5LjI0LDE5LjYyLDE5LjY0LDE5LjY0LDAsMCwxLDE5LjYyLDM5LjI0Wk0xOS42MiwyQTE3LjYyLDE3LjYyLDAsMSwwLDM3LjI0LDE5LjYyLDE3LjYzLDE3LjYzLDAsMCwwLDE5LjYyLDJaIi8+PC9nPjxnIGlkPSJQYXRoXzEiIGRhdGEtbmFtZT0iUGF0aCAxIj48cGF0aCBkPSJNNDguNjQsNTAuNjZhMSwxLDAsMCwxLS43MS0uMjlMMzIuMTYsMzQuNmExLDEsMCwwLDEsMC0xLjQyLDEsMSwwLDAsMSwxLjQxLDBMNDkuMzUsNDlhMSwxLDAsMCwxLS43MSwxLjdaIi8+PC9nPjwvZz48L2c+PC9nPjwvc3ZnPg==";
export { SvgSearch as ReactComponent };